import '../css/main.css';
import { initStoriesSlider } from './components/stories-slider';
import { initDivisionsSlider } from './components/divisions-slider';
import { init120YearsDivisionsSlider } from './components/divisions-120-years-slider';
import { initTimelineSlider } from './components/timeline-slider';
import { initTimelineTreeSlider } from './components/timeline-tree-slider';
import { initStepsSlider } from './components/steps-slider';
import { initStepsStandalone } from './components/steps-standalone';
import { initSdgSlider } from './components/sdg-slider';
import { initHeader } from './components/header';
import { initFooter } from './components/footer';
import { initSitemap } from './components/sitemap';
import { initAccordion } from './components/accordion';
import { initInvestorNav } from './components/investor-nav';
import { initCompaniesTabs } from './components/companies-tabs';
import { initTabs } from './components/tabs';
import { initCounter } from './components/counter';
import { initReportsFilter } from './components/reports-filter';
import { initDonutCharts } from './components/chart-donut';
import { initSearch } from './components/search';
import { initPressReleasesLoadMore } from './components/press-releases-load-more';
import { initPressReleasesCompactAsync } from './components/press-releases-compact-async';
import { initLatestReportTitle } from './components/latest-report-title';
import { initUpcomingEvents } from './components/upcoming-events';
import { initEventsCalendar } from './components/events';
import { initWidgets } from './components/widget';
import { initGLightbox } from './components/teams-lightbox-modal';
import { initMediaGallery } from './components/media-gallery';
import { initAnchorSmoothScroll } from './components/anchor-smooth-scroll';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Initialize components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    initStoriesSlider();
    initDivisionsSlider();
    init120YearsDivisionsSlider();
    initTimelineSlider();
    initTimelineTreeSlider();
    initStepsSlider();
    initStepsStandalone();
    initSdgSlider();
    initHeader();
    initFooter();
    initAccordion();
    initInvestorNav();
    initCompaniesTabs();
    initTabs();
    initCounter();
    initReportsFilter();
    initDonutCharts();
    initSearch();
    initPressReleasesLoadMore();
    initPressReleasesCompactAsync();
    initLatestReportTitle();
    initUpcomingEvents();
    initWidgets(); // Initialize widget loader first
    initEventsCalendar(); // Then reformat calendar after widget loads
    initGLightbox();
    initMediaGallery();
    initSitemap();
    initAnchorSmoothScroll();
});

import AOS from 'aos';
import 'aos/dist/aos.css';
document.addEventListener('DOMContentLoaded', function () {
    AOS.init({
        duration: 1000,
        once: true,
        disable: window.innerWidth < 768 // disable on mobile
    });
});